import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    container: {
        height: 'calc(100vh - 67px)',
        display: 'flex',
        overflow: 'hidden',
    },
    main: {
        flexGrow: 1,
        overflowY: 'auto',
        height: 'calc(100vh - 220px)',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
    },
    inner: {
        padding: '0px 16px 0px 0px',
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
    },

    commentAvatar: {
        height: 24,
        width: 24,
        fontSize: 11,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        backgroundColor: '#5398E6',
        color: '#fff',
      },

      alertRoot: {
        minHeight: 35,            // overall height
        paddingTop: 6,
        paddingBottom: 6,
        alignItems: 'center',
      },
      message: {
        fontSize: 14,             // text size
        lineHeight: 1.3,
      },
      icon: {
        fontSize: 18,             // leading icon size
        marginRight: 8,
      },

    /* Replaced inline styles */
    headerGrid: {
        height: 88,
        boxSizing: 'border-box',
    },
    headerRow: {
        marginBottom: 20,
    },
    mainCol: {
        paddingRight: 20,
    },
    clauseWrap: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
    },

    /* --------- Responsiveness --------- */
    /* Base (>=1920px) is above. Tweak downwards */
    '@media (max-width:1440px)': {
        main: {
            height: 'calc(100vh - 220px)',
        },
        mainCol: {
            paddingRight: 18,
        },
        clauseWrap: {
            gap: 20,
        },
    },
    '@media (max-width:1366px)': {
        mainCol: {
            paddingRight: 16,
        },
        headerGrid: {
            height: 84,
        },
        headerRow: {
            marginBottom: 16,
        },
        clauseWrap: {
            gap: 16,
        },
    },
    '@media (max-width:1024px)': {
        container: {
            height: 'calc(100vh - 56px)',
        },
        headerGrid: {
            height: 72,
        },
        mainCol: {
            paddingRight: 12,
        },
        clauseWrap: {
            gap: 12,
        },
    },
}));

export default useStyles;